import { createFileRoute } from '@tanstack/react-router';
import { AccountFormWrapper } from '@/pages/accounts/form-account';
import { PROTECTED, ACCOUNTS } from '@/lib/constants/routes';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';

const RETURN_URL = `${PROTECTED}${ACCOUNTS}`;

export const Route = createFileRoute('/protected/_layout/accounts/_layout/$id')(
  {
    ...createSheetRouteOptions(RETURN_URL),
    component: EditAccountModal,
  }
);

function EditAccountModal() {
  const { id } = Route.useParams();
  return <AccountFormWrapper id={id} returnUrl={RETURN_URL} />;
}
